module.exports = __webpack_public_path__ + "media/img/virtual-internships/student-testimonial-henry-shapiro-3957d445ec9c21173e2c8dd515bdc470.png";